<form [formGroup]="spotQuoteForm">
    <mat-form-field>
        <mat-label>Rate Quoted</mat-label>
        <input type="number" formControlName="rate">
    </mat-form-field>
</form>
<button mat-raised-button (click)="onClose()">Cancel</button>
<button mat-raised-button (click)="onSubmit()">Submit</button>